import axios from "axios";
import { API_ENDPOINT } from "../../../src/apiConstant";
import { PHONE_NUMBER, TOKEN, USER_TOKEN, MANUAL_TOKEN } from "../../Redux/types";
import { getAppsFlyerId } from "../../utils/appFlyer";

export const savePhoneNumber = (phone_number) => {
  return (dispatch) => {
    dispatch({
      type: PHONE_NUMBER,
      payload: phone_number,
    });
  };
};

export const saveToken = (dispatch, data) => {
  return (dispatch) => {
    dispatch({
      type: TOKEN,
      payload: data,
    });
  };
};
export const saveManualToken = (manual_token) => {
  return (dispatch) => {
    dispatch({
      type: MANUAL_TOKEN,
      payload: manual_token,
    });
  };
};

export const saveUserToken = (dispatch, data) => {
  // console.log("payload data", data);
  dispatch({
    type: USER_TOKEN,
    payload: data,
  });
};

// PHONE NUMBER VERIFY
export const phoneNumberVerify = (data) => {
  let url = `${API_ENDPOINT}/api/v2/authentication/phone_no_verify/`;
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

//Create On Board User
export const createOnBoardUser = (data) => {
  let url = `${API_ENDPOINT}/api/v2/authentication/create_onboard_user/`;
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const refreshToken = (data) => {
  let url = `${API_ENDPOINT}/api/refresh_tokens/`;
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          localStorage.removeItem("gpay_token");
          return reject(err);
        });
    });
};

//For Register User


export const signInUser = (data) => {
  let url = `${API_ENDPOINT}/api/authentication/authenticate_mpin/`;
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data)
        .then((res) => {
          localStorage.setItem("gpay_token", res?.data?.data?.token);

          saveUserToken(dispatch, res?.data?.data);
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const applyReferralCode = (token, referCode, clickid, partnerId) => {
  let url = `${API_ENDPOINT}/api/referral/referral_code_apply/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  let data = {
    referral_code: referCode,
    ...(clickid && { click_id: clickid }),
    partner_id: partnerId || null,
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const setNewMpin = (token, mpin) => {
  // console.log("mpin token", token, data);
  let url = `${API_ENDPOINT}/api/authentication/create_or_update_mpin/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  let data = {
    mpin: mpin,
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          // console.log(err);
        });
    });
};

export const resendOtp = (data) => {
  let url = `${API_ENDPOINT}/api/send_otp_phone/`;
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const sentOtpForappyLoan = (data, token) => {
  let url = `${API_ENDPOINT}/api/auth_send_otp_phone/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const verifyOtpForappyLoan = (data, token) => {
  let url = `${API_ENDPOINT}/api/auth_verify_otp_phone/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const verifyOtp = (data) => {
  let url = `${API_ENDPOINT}/api/verify_otp_phone/`;
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data)
        .then((res) => {
          localStorage.setItem("gpay_token", res?.data?.data?.token);
          saveUserToken(dispatch, res.data.data);
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};
export const verifyOtpPhone = (data) => {
  let url = `${API_ENDPOINT}/api/verify_otp_phone/`;
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const createOrderCard = (data, token) => {
  let url = `${API_ENDPOINT}/api/spot-order-get-create/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const checkForOrderId = (token) => {
  // console.log(token);
  let url = `${API_ENDPOINT}/api/spot-order-get-create/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};
export const cibilFormAssign = (token, data) => {
  // console.log("cibilFormAssign cibilFormAssign", token, data);
  let url = `${API_ENDPOINT}/api/v2/cibil_form_assign/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const karza = (token, data) => {
  // console.log("Karza assign", token, data);
  let url = `${API_ENDPOINT}/api/v2/karza_api/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};
export const emailOtpVerify = (params) => {
  let url = `${API_ENDPOINT}/api/authentication/email_otp_verify_register/`;

  const registerFrom = localStorage.getItem("register_from");
  const payload = {
    ...params,
    ...(registerFrom && { register_from: registerFrom }),
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios

        .post(url, payload)

        .then((res) => {
         
          localStorage.setItem("gpay_token", res?.data?.data?.token);
          // localStorage.setItem("gpay_refresh_token", res?.data?.data?.refresh);
          saveUserToken(dispatch, res.data.data.token);
          return resolve(res);
        })

        .catch((err) => {
          return reject(err);
        });
    });
};

export const registerUser = (data) => { 
  const url = `${API_ENDPOINT}/api/authentication/register_user/`;

  const receivedKey = localStorage.getItem("receivedKey");
  const registerFrom = localStorage.getItem("register_from");
  const payload = {
    ...data,
    ...(receivedKey && { source: "pl-landing" }),
    ...(registerFrom && { register_from: registerFrom }),
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, payload)
        .then((res) => {
          const token = res?.data?.data?.token;
          if (token) {
            localStorage.setItem("gpay_token", token);
            saveUserToken(dispatch, token);
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
};
  


export const sendOtpNotExist = (token, data ) => {
  let url = `${API_ENDPOINT}/api/send_otp_phone/not_exist_user/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};


export const updatePhone = (token, data) => {
  let url = `${API_ENDPOINT}/api/user_details/update_phone/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};



export const fetchUTMLogo = (refer_code) => {
  let url = `${API_ENDPOINT}/api/authentication/utm_logo/`;
  let config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  let body = {
    refer_code: refer_code,
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, body, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const sendBasicDetails = (token,userId) => async (dispatch) => {
  // Skip if not in app environment
  // if (!window.app) {
  //   console.log("Skipping: not running inside app");
  //   return null;
  // }
  const appsFlyerId = getAppsFlyerId(userId);


  if (!appsFlyerId) {
    console.log("Skipping: AppsFlyer ID not available");
    return null;
  }

  try {
    const url = `${API_ENDPOINT}/api/user_details/basic_details/`;

    const { data } = await axios.post(
      url,
      {
        appsflyer_id: appsFlyerId,
        os: "A",
      },
      {
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    console.log("sendBasicDetails success:", data);
    return data;
  } catch (error) {
    console.error("sendBasicDetails error:", error);
    throw error;
  }
};
